/* unplugin-vue-components disabled */import { render } from "./commissionExtra.vue?vue&type=template&id=69231f9a&scoped=true"
import script from "./commissionExtra.vue?vue&type=script&lang=js"
export * from "./commissionExtra.vue?vue&type=script&lang=js"

import "./commissionExtra.vue?vue&type=style&index=0&id=69231f9a&lang=less&scoped=true"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69231f9a"]])

export default __exports__